import { render } from "./MbaHrm.vue?vue&type=template&id=7621af48"
import script from "./MbaHrm.vue?vue&type=script&lang=js"
export * from "./MbaHrm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__